import { render, staticRenderFns } from "./SbpEnableModal.vue?vue&type=template&id=1bf31799&scoped=true&"
import script from "./SbpEnableModal.vue?vue&type=script&lang=ts&"
export * from "./SbpEnableModal.vue?vue&type=script&lang=ts&"
import style0 from "./SbpEnableModal.vue?vue&type=style&index=0&id=1bf31799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf31799",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VForm,VIcon,VSwitch})
